import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmployeeListItemDto } from "../models/employee/employee";
import { getEmployees } from "../services/employeeServiceNew";

export interface EmployeesState {
    employees: EmployeeListItemDto[];
    groupEmployees?: EmployeeListItemDto[];
    groupEmployeesGroupId?: string | null;
}

const initialState: EmployeesState = {
    employees: [],
    groupEmployees: [],
    groupEmployeesGroupId: null,
};

export const employeesSlice = createSlice({
    name: "employees",
    initialState,
    reducers: {
        setEmployees: (state, action: PayloadAction<EmployeeListItemDto[]>) => {
            state.employees = action.payload;
        }
        ,
        setGroupEmployees: (state, action: PayloadAction<{ groupId?: string | null; employees: EmployeeListItemDto[] }>) => {
            state.groupEmployees = action.payload.employees;
            state.groupEmployeesGroupId = action.payload.groupId ?? null;
        }
    }
});

export const fetchEmployees = createAsyncThunk<EmployeeListItemDto[]>(
    "employees/list",
    async(_, thunkApi) => {
        const res = await getEmployees(null, thunkApi.signal);
        thunkApi.dispatch(setEmployees(res?.data));
        return res?.data;
    }
);

export const {
    setEmployees,
    setGroupEmployees
} = employeesSlice.actions;

export const employeesReducer = employeesSlice.reducer;
